import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { MdAvTimer, MdOndemandVideo, MdModeEdit } from 'react-icons/md';
import styled from 'styled-components';

import useAuth from '../../../../hooks/useAuth';
import SectionHeader from '../../../../components/SectionHeader';
import { useAvatarUrl } from '../../../../hooks/useAvatarUrl';
import { useHeader } from '../../../../components/Header/hooks';

const StudentInfo = () => {
  const { user } = useAuth();
  const { userAvatar, resetAvatar } = useAvatarUrl();
  const { score } = useHeader();

  const changeAvatar = useCallback(async () => {
    await resetAvatar();
  }, [resetAvatar]);

  return (
    <StudentInfos>
      <SectionHeader>
        <h1>{user.profile.name}</h1>
      </SectionHeader>

      <StudentInfoContainer>
        <div className="flex-row">
          <StudentAvatar src={userAvatar.uri} alt="Avatar" />
          <ChangeAvatar
            size={20}
            color="#07224B"
            title="Gerar novo avatar aleatório"
            onClick={changeAvatar}
          />
        </div>
        <InformationWrapper>
          <StudentMainInfo>
            <FontBlue className="typography-sans">Sobre:</FontBlue>
            <FontBlue className="typography-sans">Turma:</FontBlue>
            {/* <FontBlue className="typography-sans fonts">
            Interesses: Sem interesses associados
          </FontBlue> */}
          </StudentMainInfo>

          <CardsContainer>
            <CardBox>
              <MdAvTimer size={60} color="#269912" />
              <FontWhite className="typography-sans">
                Tempo na plataforma:
              </FontWhite>
              <h3 className="typography-sans font-white">00</h3>
            </CardBox>
            <CardBox>
              <MdOndemandVideo size={60} color="#269912" />
              <FontWhite className="typography-sans">
                Aulas assistidas:
              </FontWhite>
              <h3 className="typography-sans font-white">00</h3>
            </CardBox>
            <CardBox>
              <ItCoin src="/assets/coin.svg" alt="Itus" id="it-coin" />
              <FontWhite className="typography-sans">ITcoins:</FontWhite>
              <h3 className="typography-sans font-white">
                {score.balance || '00'}
              </h3>
            </CardBox>
          </CardsContainer>
        </InformationWrapper>
      </StudentInfoContainer>

      <MediaQuery />
    </StudentInfos>
  );
};

export default StudentInfo;

const StudentInfos = styled.div`
  font-size: 10px;
`;

const InformationWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  /* background-color: red; */
`;

const StudentInfoContainer = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: center;
  gap: 10px;
`;

const StudentAvatar = styled.img`
  width: 100%;
  max-width: 160px;
`;

const ChangeAvatar = styled(MdModeEdit)`
  border-radius: 50%;
  &:hover {
    transition: 0.1s;
    transform: scale(1.2);
    background-color: gray;
  }
`;

const StudentMainInfo = styled.div`
  width: auto;
  max-width: 40%;
  font-size: 1.6em;
`;

const TypographySans = styled.p`
  font-family: 'Roboto', sans-serif;
`;

const FontBlue = styled(TypographySans)`
  font-family: ${({ theme }) => theme.fonts.cantora};
  /* font-size: ${({ theme }) => theme.fontSizes.md}; */
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  color: ${({ theme }) => theme.colors.secondary};
  /* margin-bottom: 0.75rem; */
`;

const FontWhite = styled(TypographySans)`
  color: #fff;
`;

const CardsContainer = styled.div`
  font-size: 1.3em;
  flex-grow: 1;
  display: grid;
  grid-template-columns: repeat(auto-fit, 10rem);
  grid-auto-rows: 10rem;
  gap: 4rem;
  justify-content: end;
`;

const CardBox = styled.div`
  border-radius: 5%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #07224b;
`;

const ItCoin = styled.img`
  width: 60px;
`;

const MediaQuery = styled.div`
  @media (max-width: 768px) {
    ${StudentInfos} {
      font-size: 8px;
    }

    ${StudentInfoContainer} {
      width: 100%;
      flex-direction: column;

      ${StudentMainInfo} {
        min-width: 80%;
        text-align: center;
      }

      ${CardsContainer} {
        grid-template-columns: repeat(auto-fit, 120px);
        grid-auto-rows: 120px;
      }
    }
  }
`;
